<template>
    <v-layout
        row
        align-center
    >
        <v-flex
            class="pa-2 ma-1"
        >
            <breadcrumbs
                :items="breadcrumbsItems"
            ></breadcrumbs>
            <v-card-title>Groups</v-card-title>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col style="text-align: right;" class="pr-12">
                    <v-btn class="ma-1"
                           small
                           color="success"
                           @click="create()"> + Add Group
                    </v-btn>
                </v-col>
            </v-row>
            <v-card
                max-height="400"
            >
                <v-data-table
                    :headers="headers"
                    item-key="name"
                    :items="Object.values(groups)"
                    :search="search"
                    dense
                    class="display-3 font-weight-medium"
                    items-per-page="30"
                    fixed-header="true"
                    height="400"
                >
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                            class="mr-8"
                            @click="edit(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            color="red"
                            @click="deleteGroup(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";

export default {
    name: 'groups',
    props: ['groups'],
    data: () => ({
        headers: [
            {
                text: 'ID',
                align: 'start',
                value: 'id',
            },
            {
                text: 'Group',
                value: 'name',
            },
            {
                text: 'Description',
                value: 'description',
            },
            {
                text: 'Actions',
                value: 'actions',
                sortable: false
            }
        ],
        search: null,
        breadcrumbsItems: '',
    }),
    methods: {
        create() {
            window.location.href = 'group/create'
        },
        edit(g) {
            window.location.href = 'group/' + g.id + '/edit'
        },
        deleteGroup(g) {
            const i = this.groups.indexOf(g);
            if (confirm('Are you sure you want to delete this group?')) {
                axios.delete('/group/' + g.id).then(response => {
                    this.groups.splice(i, 1);
                });
            }
        },
    },
    beforeMount() {
        this.breadcrumbsItems = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: 'Groups',
            },
        ];
    }
}
</script>

<style>
.v-data-table-header th {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Groups/Groups.vue